export const userAgentIsIphone = () => navigator.platform === "iPhone";

export const userAgentIsIpad = () => navigator.platform === "iPad";

export const userAgentIsAndroid = () => navigator.userAgent.toLowerCase().indexOf("android") > -1;

export const userAgentIsIOS = () => userAgentIsIphone() || userAgentIsIpad();

export const userAgentIsMobile = () => userAgentIsIOS() || userAgentIsAndroid();
